"use client";

import { useUser } from "@clerk/nextjs";
import { useTranslations } from "next-intl";
import { buttonVariants } from "@/components/ui/button";
import { SheetClose } from "@/components/ui/sheet";
import { privateProps } from "@/features/analytics/lib/masking";
import { AUTH_PRIMARY_BUTTON } from "@/features/auth/lib/auth-button-styles";
import { Link } from "@/i18n/navigation";
import { UserAvatar } from "@/components/header/user-avatar";
import { cn } from "@/lib/utils";

/** Signed-in header of the mobile menu: the account row with the order CTA. */
export const MobileMenuUser = () => {
  const t = useTranslations("header");
  const { user } = useUser();

  const email = user?.primaryEmailAddress?.emailAddress;

  return (
    <div className="flex flex-col gap-4 px-4 py-3">
      <div className="flex items-center gap-3">
        <UserAvatar className="size-12" />
        <div
          className="flex min-w-0 flex-col justify-center"
          {...privateProps}
        >
          <span className="truncate text-base text-text leading-6">
            {user?.fullName ?? email}
          </span>
          <span className="truncate text-sm text-text-subtle leading-[22px]">
            {email}
          </span>
        </div>
      </div>
      <SheetClose asChild>
        <Link
          className={cn(
            buttonVariants({ variant: "ghost" }),
            AUTH_PRIMARY_BUTTON
          )}
          data-pw="mobile-menu-order-diet"
          href={{ pathname: "/diets/[[...slug]]", params: { slug: [] } }}
        >
          {t("orderDiet")}
        </Link>
      </SheetClose>
    </div>
  );
};
